// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewSticker_wrapper__Of241"};